import * as React from 'react';
import { Href } from 'redux-little-router';

import { Bem } from '../../service/Bem/Bem';
import { LinkTarget } from '../../typings/common';
import { Shape2, Shape2Icon } from '../Shape2/Shape2';
import { RouteStyledLink, StyledLinkTheme } from '../StyledLink/StyledLink';

import './TableCellLink.css';

const BLOCK = 'table-cell-link';

interface TableCellLinkProps {
    href: Href;
    target?: LinkTarget;
}

export class TableCellLink extends React.PureComponent<TableCellLinkProps> {
    render() {
        const { href, target } = this.props;
        return (
            <div className={Bem.cls(BLOCK)}>
                <RouteStyledLink
                    cls={Bem.cls(BLOCK, 'link')}
                    theme={StyledLinkTheme.icon}
                    href={href}
                    target={target}
                >
                    <Shape2 icon={Shape2Icon.link2} width={15} height={15} />
                </RouteStyledLink>
            </div>
        );
    }
}
